module.exports = __webpack_public_path__ + "static/media/modernmodesty.7ba8e429.png";